import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
// import {
//   MatInputModule,
//   MatButtonModule,
//   MatFormFieldModule,
//   MatSelectModule,
//   MatIconModule,
//   MatSliderModule,
//   MatNativeDateModule,
//   MatAutocompleteModule,
//   MatCheckboxModule,
//   MatMenuModule,
//   MatToolbarModule,
//   MatRadioModule,
// } from "@angular/material";
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatNativeDateModule } from '@angular/material/core';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { TaskListComponent } from "../headquarters/task-list/task-list.component";
import { UserQlySectionManagePopupComponent } from "src/app/components/common/user-qly-section-manage-popup/user-qly-section-manage-popup.component";
import { KpiPopupComponent } from "./kpi-popup/kpi-popup.component";
import { TaskListNestedCommentComponent } from "../headquarters/task-list-nested-comment/task-list-nested-comment.component";
import { TaskDetailsOverviewComponent } from "../headquarters/task-details-overview/task-details-overview.component";
import { TaskListCommentComponent } from "../headquarters/task-list-comment/task-list-comment.component";
import { TasksViewReplyComponent } from "src/app/components/common/tasks-view-reply/tasks-view-reply.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { NgxImageCompressService } from "ngx-image-compress";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatLegacyChipsModule as MatChipsModule } from "@angular/material/legacy-chips";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { DpDatePickerModule } from "ng2-date-picker";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {ToastModule} from 'primeng/toast';
// import { GoogleChartsModule } from 'angular-google-charts';
import { ScrollingModule } from "@angular/cdk/scrolling";
import { NgbModule, NgbActiveModal, NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { ClickOutsideModule } from "ng-click-outside";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { MultiSelectModule } from "primeng/multiselect";
import { AccordionModule } from "primeng/accordion";
import { MatBadgeModule } from "@angular/material/badge";
import { EditorModule } from "primeng/editor";
import { CalendarModule } from "primeng/calendar";
import { CheckboxModule } from "primeng/checkbox";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputNumberModule } from "primeng/inputnumber";
import { MenubarModule } from 'primeng/menubar';
import { SliderModule } from "primeng/slider";
import { SidebarModule } from "primeng/sidebar";
import { TabViewModule } from "primeng/tabview";
import { NgxMaskModule, IConfig } from "ngx-mask";
import { BsDropdownModule, BsDropdownConfig } from "ngx-bootstrap/dropdown";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { RadioButtonModule } from 'primeng/radiobutton';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { PaginatorModule } from 'primeng/paginator';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

import { FullCalendarModule } from '@fullcalendar/angular';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import timegridPlugin from '@fullcalendar/timegrid';
// import interactionPlugin from '@fullcalendar/interaction';
// import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';

import { FilterComponent } from "../../components/common/filter/filter.component";
import { ScrollTopService } from "../../services/scroll-top.service";
import { HeaderComponent } from "../../layouts/header/header.component";
import { ProbingHeaderComponent } from "../../layouts/probing-header/probing-header.component";
import { ProductHeaderComponent } from "../../layouts/product-header/product-header.component";
import { SidebarComponent } from "../../layouts/sidebar/sidebar.component";
import { MarketplaceSidebarComponent } from "../../layouts/marketplace-sidebar/marketplace-sidebar.component";
import { FooterComponent } from "../../layouts/footer/footer.component";
import { RemoveWhiteSpacePipe } from "../../common/pipes/remove-white-space.pipe";
import { ConfirmationComponent } from "../../components/common/confirmation/confirmation.component";
import { SubmitLoaderComponent } from "../../components/common/submit-loader/submit-loader.component";
import { SuccessComponent } from "../../components/common/success/success.component";
import { SuccessModalComponent } from "../../components/common/success-modal/success-modal.component";
import { ProductMakeComponent } from "../../components/common/product-make/product-make.component";
import { WorkstreamListComponent } from "../../components/common/workstream-list/workstream-list.component";
import { ApplicationComponent } from "../../components/common/application/application.component";
import { TagViewComponent } from "../../components/common/tag-view/tag-view.component";
import { ErrorCodeViewComponent } from "../../components/common/error-code-view/error-code-view.component";
import { AttachmentViewComponent } from "../../components/common/attachment-view/attachment-view.component";
import { SystemInfoViewComponent } from "../../components/common/system-info-view/system-info-view.component";
import { ModelsComponent } from "../../components/common/models/models.component";
import { YearsComponent } from "../../components/common/years/years.component";
import { SecWorkstreamsComponent } from "../../components/common/sec-workstreams/sec-workstreams.component";
import { TagsComponent } from "../../components/common/tags/tags.component";
import { ActionFormComponent } from "../../components/common/action-form/action-form.component";
import { ErrorCodeListsComponent } from "../../components/common/error-code-lists/error-code-lists.component";
import { ManageListComponent } from "../../components/common/manage-list/manage-list.component";
import { ManageGeoListComponent } from "../../components/common/manage-geo-list/manage-geo-list.component";
import { RelatedThreadListsComponent } from "../../components/common/related-thread-lists/related-thread-lists.component";
import { MakeComponent } from "../../components/common/make/make.component";
import { FileAttachmentComponent } from "../../components/common/file-attachment/file-attachment.component";
import { FileAttachmentOldComponent } from '../../components/common/file-attachment-old/file-attachment-old.component';
import { FileAttachmentS3Component } from '../../components/common/file-attachment-s3/file-attachment-s3.component';
import { FileUploadModule } from "primeng/fileupload";
import { UploadAttachmentsComponent } from "../../components/common/upload-attachments/upload-attachments.component";
import { UploadExistingComponent } from '../../components/common/upload-existing/upload-existing.component';
import { InputTextModule } from "primeng/inputtext";
import { LandingpageHeaderComponent } from "../../layouts/landingpage-header/landingpage-header.component";
import { LandingLeftSideMenuComponent } from "../../components/common/landing-left-side-menu/landing-left-side-menu.component";
import { DomainMembersComponent } from "../../components/common/domain-members/domain-members.component";
import { AnnouncementListComponent } from "../../components/common/announcement-list/announcement-list.component";
import { AnnouncementListSolrComponent } from "../../components/common/announcement-list-solr/announcement-list-solr.component";
import { AnnouncementUserViewComponent } from "../../components/common/announcement-user-view/announcement-user-view.component";
import { AnnouncementUserViewSolrComponent } from "../../components/common/announcement-user-view-solr/announcement-user-view-solr.component";
import { AnnouncementWidgetsComponent } from "../../components/common/announcement-widgets/announcement-widgets.component";
import { EscalationWidgetsComponent } from "../../components/common/escalation-widgets/escalation-widgets.component";
import { RecentViewedWidgetsComponent } from "../../components/common/recent-viewed-widgets/recent-viewed-widgets.component";
import { RecentSearchesWidgetsComponent } from "../../components/common/recent-searches-widgets/recent-searches-widgets.component";
import { MyMetricsWidgetsComponent } from "../../components/common/my-metrics-widgets/my-metrics-widgets.component";
import { LandingReportWidgtsComponent } from "../../components/common/landing-report-widgts/landing-report-widgts.component";
import { AddLinkComponent } from "../../components/common/add-link/add-link.component";
import { MediaTypesComponent } from "../../components/common/media-types/media-types.component";
import { AppUserNotificationsComponent } from "../../components/common/app-user-notifications/app-user-notifications.component";
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { environment } from "../../../environments/environment";
import { HttpClientModule } from "@angular/common/http";
import { FcmMessagingService } from "../../services/fcm-messaging/fcm-messaging.service";
import { TotaluserPopupComponent } from "./totaluser-popup/totaluser-popup.component";
import { ManageUserComponent } from "../../components/common/manage-user/manage-user.component";
import { ThreadsPageComponent } from "../../components/common/threads-page/threads-page.component";
import { StatusComponent } from "../../components/common/status/status.component";
import { MediaInfoComponent } from "../../components/common/media-info/media-info.component";
import { PartsListComponent } from "../../components/common/parts-list/parts-list.component";
import { PartCatgComponent } from '../../components/common/part-catg/part-catg.component';
import { GridsterModule } from "angular-gridster2";
import { NgxMasonryModule } from "ngx-masonry";
import { NgxYoutubePlayerModule } from "ngx-youtube-player";
import { PhoneMaskDirective } from "../../phone-mask.directive";
import { ViewPolicyComponent } from "../../components/common/view-policy/view-policy.component";
// import { DragDropDirective } from 'src/app/common/directive/drag-drop.directive';
import { CustomerListSolrComponent } from '../../components/common/customer-list-solr/customer-list-solr.component';

import {
  PerfectScrollbarModule,
  PerfectScrollbarConfigInterface,
  PERFECT_SCROLLBAR_CONFIG,
} from "ngx-perfect-scrollbar";
import { EmptyContainerComponent } from "../../components/common/empty-container/empty-container.component";
import { AuthFooterComponent } from "../../components/common/auth-footer/auth-footer.component";
import { AuthRightPanelComponent } from "../../components/common/auth-right-panel/auth-right-panel.component";
import { AuthSuccessComponent } from "../../components/common/auth-success/auth-success.component";
import { DomainUrlComponent } from "../../components/common/domain-url/domain-url.component";
import { ForgotpasswordComponent } from "../../components/common/forgotpassword/forgotpassword.component";
import { NonUserComponent } from "../../components/common/non-user/non-user.component";
import { ContentPopupComponent } from '../../components/common/content-popup/content-popup.component';
import { VerifyEmailComponent } from "../../components/common/verify-email/verify-email.component";
import { OtpComponent } from '../../components/common/otp/otp.component';
import { OtpModalPopupComponent } from '../../components/common/otp-modal-popup/otp-modal-popup.component';
import { ProfileBusinessComponent } from "../../components/common/profile-business/profile-business.component";
import { ProfilePersonalComponent } from "../../components/common/profile-personal/profile-personal.component";
import { ProfileMetricsComponent } from "../../components/common/profile-metrics/profile-metrics.component";
import { ProfileCertificateComponent } from "../../components/common/profile-certificate/profile-certificate.component";
import { ChangePasswordComponent } from "../../components/common/change-password/change-password.component";
import { CreateFolderComponent } from "../../components/common/create-folder/create-folder.component";
import { CreateCategoryComponent } from '../../components/common/create-category/create-category.component';
import { MultiSelectComponent } from "../../components/common/multi-select/multi-select.component";
import { DynamicFieldsComponent } from "../../components/common/dynamic-fields/dynamic-fields.component";
import { DynamicValuesComponent } from "../../components/common/dynamic-values/dynamic-values.component";
import { DynamicPageViewComponent } from '../../components/common/dynamic-page-view/dynamic-page-view.component';
import { DynamicDetailHeaderComponent } from '../../layouts/dynamic-detail-header/dynamic-detail-header.component';
import { ImageCropperComponent } from "../../components/common/image-cropper/image-cropper.component";
import { ImageCropperModule } from "../../image-cropper/image-cropper.module";
import { CertificationComponent } from "../../components/common/certification/certification.component";
import { FollowersFollowingComponent } from "../../components/common/followers-following/followers-following.component";
import { CommonNotificationsComponent } from "../../components/common/common-notifications/common-notifications.component";
import { NewEditHeaderComponent } from '../../layouts/new-edit-header/new-edit-header.component';
import { ThreadDetailHeaderComponent } from "../../layouts/thread-detail-header/thread-detail-header.component";
import { ThreadDetailViewComponent,HighlightSearchThreaddetail } from "../../components/common/thread-detail-view/thread-detail-view.component";
import { DetailViewComponent } from "../../components/common/detail-view/detail-view.component";
import { DocumentApprovalComponent } from 'src/app/components/common/document-approval/document-approval.component';
import { ListComponent } from 'src/app/components/common/document-approval/list/list.component';
import { KaizenApprovalComponent } from 'src/app/components/common/kaizen-approval/kaizen-approval.component';
import { KzListComponent } from 'src/app/components/common/kaizen-approval/kz-list/kz-list.component';
import { ApprovedKzListComponent } from 'src/app/components/common/kaizen-approval/approved-kz-list/approved-kz-list.component';
import { DocumentsComponent } from "src/app/components/common/documents/documents.component";
import { DocumentsNewComponent } from 'src/app/components/common/documents-new/documents-new.component';
import { DocumentsOldComponent } from 'src/app/components/common/documents-old/documents-old.component';
import { FilesComponent } from "src/app/components/common/documents/files/files.component";
import { FoldersComponent } from "src/app/components/common/documents/folders/folders.component";
import { DocInfoComponent } from "src/app/components/common/doc-info/doc-info.component";
import { DirectoryInfoComponent } from 'src/app//components/common/directory-info/directory-info.component';
import { TableModule } from "primeng/table";
import { CountryPhonenumberComponent } from "../../components/common/country-phonenumber/country-phonenumber.component";
import { ExportPopupComponent } from "../../components/common/export-popup/export-popup.component";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { KnowledgeArticlesComponent } from "src/app/components/common/knowledge-articles/knowledge-articles.component";
import { DaysLoginPOPUPComponent } from '../../components/common/days-login-popup/days-login-popup.component';
import { WelcomeHomeComponent } from "../../components/common/welcome-home/welcome-home.component";
import { ManageProductCodesComponent } from "../../components/common/manage-product-codes/manage-product-codes.component";
import { VehicleModelsComponent } from "src/app/components/vehicle-models/vehicle-models.component";
import { EmissionsComponent } from '../../components/emissions/emissions.component';
import { ManageListComponentGTS } from "src/app/components/common/manage-list-gts/manage-list.component";
import { GtsListsComponent } from "src/app/components/common/gts-lists/gts-lists.component";
import { GtsListsSolrComponent } from "src/app/components/common/gts-lists-solr/gts-lists-solr.component";
import { SibListComponent } from 'src/app/components/common/sib-list/sib-list.component';
import { SibApplicationComponent } from 'src/app/components/common/sib-application/sib-application.component';
import { SelectCountryComponent } from '../../components/common/select-country/select-country.component';
import { StartGtsComponent } from '../../components/common/start-gts/start-gts.component';
import { KnowledgeBaseListComponent } from '../../components/common/knowledge-base-list/knowledge-base-list.component';
import { DirectoryListComponent } from 'src/app/components/common/directory-list/directory-list.component';
import { CardModule } from "primeng/card";
import { PanelModule } from 'primeng/panel';
import { ChipModule } from 'primeng/chip';
import { ProgressBarModule } from 'primeng/progressbar';
import { MenuModule } from 'primeng/menu';
import { CarouselModule } from "primeng/carousel";
import { GalleriaModule } from 'primeng/galleria';
import { CustomAccordionTabComponent } from "src/app/components/common/custom-accordion-tab/custom-accordion-tab.component";
import { SupportRequestWidgetComponent } from "src/app/components/common/support-request-widget/support-request-widget.component";
import { RecentTechInfoWidgetsComponent } from 'src/app/components/common/recent-tech-info-widgets/recent-tech-info-widgets.component';
import { MySupportRequestWidgetsComponent } from 'src/app/components/common/my-support-request-widgets/my-support-request-widgets.component';
import { MyRoWidgetsComponent } from "src/app/components/common/my-ro-widgets/my-ro-widgets.component";
import { MyPinnedContentComponent } from 'src/app/components/common/my-pinned-content/my-pinned-content.component';
import { DialogPopupComponent } from 'src/app/components/common/dialog-popup/dialog-popup.component';
import { MediaUploadComponent } from 'src/app/components/media-upload/media-upload.component';
import { MediaAttachmentComponent } from 'src/app/components/common/media-attachment/media-attachment.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ListboxModule } from 'primeng/listbox';
import { SafePipePipe } from 'src/app/common/pipes/safe-pipe.pipe';
import { SafeHtmlPipe } from '../../common/pipes/safe-html.pipe';
import { RemoveMediaComponent } from 'src/app/components/common/remove-media/remove-media.component';
import { ChipsModule } from 'primeng/chips';
import { DispatchPageComponent } from "src/app/components/common/dispatch-page/dispatch-page.component";
import { DispatchPageSolrComponent } from 'src/app/components/common/dispatch-page-solr/dispatch-page-solr.component';
// import { GMapModule } from 'primeng/gmap';
import { AudioDescAttachmentComponent } from 'src/app/components/common/audio-desc-attachment/audio-desc-attachment.component';
import { AudioAttachmentViewComponent } from 'src/app/components/common/audio-attachment-view/audio-attachment-view.component';
import { DynamicAttachmentComponent } from 'src/app/components/common/dynamic-attachment/dynamic-attachment.component';
import { DynamicAttachmentOldComponent } from 'src/app/components/common/dynamic-attachment-old/dynamic-attachment-old.component';
import { DynamicAttachmentViewComponent } from 'src/app/components/common/dynamic-attachment-view/dynamic-attachment-view.component';
import { TagModule } from 'primeng/tag';
import { KaCategoryComponent } from 'src/app/components/common/ka-category/ka-category.component';
import { DocListComponent } from 'src/app/components/common/documents/doc-list/doc-list.component';
import { ExportFileComponent } from 'src/app/components/common/export-file/export-file.component';
import { StandardReportListComponent } from 'src/app/components/common/standard-report-list/standard-report-list.component';
import { TimelineModule } from "primeng/timeline";
import { NoPermissionPopupComponent } from 'src/app/components/common/no-permission-popup/no-permission-popup.component';
import { TechsupportListComponent } from 'src/app/components/common/techsupport-list/techsupport-list.component';
import { TechStatusListComponent } from 'src/app/components/common/tech-status-list/tech-status-list.component';
import { TechsupportTeamListComponent } from 'src/app/components/common/techsupport-team-list/techsupport-team-list.component';
import { MyTicketsWidgetsComponent } from 'src/app/components/common/my-tickets-widgets/my-tickets-widgets.component';
import { TeamSupportRequestWidgetsComponent } from 'src/app/components/common/team-support-request-widgets/team-support-request-widgets.component';
import { RegisteredTrainingsWidgetsComponent } from 'src/app/components/common/registered-trainings-widgets/registered-trainings-widgets.component';
import { TeamMembersStatusWidgetsComponent } from 'src/app/components/common/team-members-status-widgets/team-members-status-widgets.component';
import { YourPerformanceStatsWidgetsComponent } from 'src/app/components/common/your-performance-stats-widgets/your-performance-stats-widgets.component';
import { RecentMacrosWidgetsComponent } from 'src/app/components/common/recent-macros-widgets/recent-macros-widgets.component';
import { OpportunityListsComponent } from 'src/app/components/common/opportunity-lists/opportunity-lists.component';
import { RequiredFieldsComponent } from 'src/app/components/common/required-fields/required-fields.component';
import { ThreadViewRecentComponent } from '../../components/common/thread-view-recent/thread-view-recent.component';
import { ThreadViewReplyComponent } from '../../components/common/thread-view-reply/thread-view-reply.component';
import { ThreadViewReplyPublicComponent } from '../../components/common/thread-view-reply-public/thread-view-reply-public.component';
import { ThreadApprovalComponent } from 'src/app/components/common/thread-approval/thread-approval.component';
import { PaymentControllerComponent } from "src/app/components/common/payment-controller/payment-controller.component";
import { PopupComponent } from "../chat/chat-page/popup/popup.component";
import { ChatReplyMessagePopupComponent } from "../chat/chat-reply-message-popup/chat-reply-message-popup.component";
import { ManualsPaymentControllerComponent } from "src/app/components/common/manuals-payment-controller/manuals-payment-controller.component";
import { PresetsManageComponent } from '../../components/common/presets-manage/presets-manage.component';
import { PresetsListComponent } from '../../components/common/presets-list/presets-list.component';
import { BugAndFeatureComponent } from "src/app/components/common/bug-and-feature/bug-and-feature.component";
import { BugFeaDetailsComponent } from "src/app/components/common/bug-fea-details/bug-fea-details.component";
import { ViewTraningDetailComponent } from '../../components/common/view-traning-detail/view-traning-detail.component';
import { MarketplaceHeaderComponent } from '../../layouts/marketplace-header/marketplace-header.component';
import { MarketplaceFooterComponent } from '../../layouts/marketplace-footer/marketplace-footer.component';
import { MarketplaceSystemactivityComponent } from '../../components/common/marketplace-systemactivity/marketplace-systemactivity.component';
import { ShopListComponent } from 'src/app/components/common/shop-list/shop-list.component';
import { ShopListMapComponent } from 'src/app/components/common/shop-list-map/shop-list-map.component';
import { ViewDocumentDetailComponent } from 'src/app/components/common/view-document-detail/view-document-detail.component';
import { ViewAnnouncementDetailComponent } from 'src/app/components/common/view-announcement-detail/view-announcement-detail.component';
import { AuditListComponent } from 'src/app/components/common/audit-list/audit-list.component';
import { InspectionListComponent } from 'src/app/components/common/inspection-list/inspection-list.component';
import { ViewKaDetailComponent } from 'src/app/components/common/view-ka-detail/view-ka-detail.component';
import { RepairOrderListComponent } from 'src/app/components/common/repair-order-list/repair-order-list.component';
import { ViewRoDetailComponent } from 'src/app/components/common/view-ro-detail/view-ro-detail.component';
import { RepairOrderDetailViewComponent } from 'src/app/components/common/repair-order-detail-view/repair-order-detail-view.component';
import { RepairOrderManageComponent } from 'src/app/components/common/repair-order-manage/repair-order-manage.component';
import { FaqListComponent } from 'src/app/components/common/faq-list/faq-list.component';
import { RoEstimationComponent } from 'src/app/components/common/ro-estimation/ro-estimation.component';
import { CustomerListComponent } from 'src/app/components/common/customer-list/customer-list.component';
import { SearchFilterComponent,HighlightSearchFilter } from 'src/app/layouts/search-filter/search-filter.component';
import { FixThreadsComponent } from 'src/app/components/common/fix-threads/fix-threads.component';
import { DashSummaryTopComponent } from 'src/app/components/common/dash-summary-top/dash-summary-top.component';
import { DashSummaryCenterComponent } from 'src/app/components/common/dash-summary-center/dash-summary-center.component';
import { KnowledgeArticlesSolrComponent } from 'src/app/components/common/knowledge-articles-solr/knowledge-articles-solr.component';
import { KaCategorySolrComponent } from 'src/app/components/common/ka-category-solr/ka-category-solr.component';
import { AdasListComponent } from 'src/app/components/common/adas-list/adas-list.component';
import { AdasFilesComponent } from 'src/app/components/common/adas-files/adas-files.component';
import { AdasViewComponent } from 'src/app/components/common/adas-view/adas-view.component';
import { GtsSessionsListComponent } from 'src/app/components/common/gts-sessions-list/gts-sessions-list.component';
import { HeadquartersListComponent } from 'src/app/components/common/headquarters-list/headquarters-list.component';
import { HeadquartersHomeComponent } from 'src/app/components/common/headquarters-home/headquarters-home.component';
import { PaymentPopupComponent } from "src/app/components/common/payment-popup/payment-popup.component";
import { RoEstimateListComponent } from 'src/app/components/common/ro-estimate-list/ro-estimate-list.component';
import { RoEstimateTopTemplateComponent } from 'src/app/components/common/ro-estimate-top-template/ro-estimate-top-template.component';
import { SearchHistoryListComponent } from 'src/app/components/common/search-history-list/search-history-list.component';
import { ScannedvinsListComponent } from 'src/app/components/common/scannedvins-list/scannedvins-list.component';
import { ScannedvinsListNewComponent } from 'src/app/components/common/scannedvins-list-new/scannedvins-list-new.component';
import { DiagnosticProgrammingListComponent } from 'src/app/components/common/diagnostic-programming-list/diagnostic-programming-list.component';
import { UnProcessedListComponent } from 'src/app/components/common/un-processed-list/un-processed-list.component';
import { LogslistComponent } from 'src/app/components/common/logslist/logslist.component';
import { NpsVpsScoreListComponent } from 'src/app/components/common/nps-vps-score-list/nps-vps-score-list.component';
import { ManageContentModelFilesComponent } from 'src/app/components/common/manage-content-model-files/manage-content-model-files.component';
import { ManageContentModelImagesComponent } from 'src/app/components/common/manage-content-model-images/manage-content-model-images.component';
import { ManageContentSplashImageComponent } from 'src/app/components/common/manage-content-splash-image/manage-content-splash-image.component';
import { ManageContentDirectoryListComponent } from 'src/app/components/common/manage-content-directory-list/manage-content-directory-list.component';
import { StripeModule } from 'stripe-angular';
import { MarketPlaceReportDetailsComponent } from "src/app/components/service-market-place/market-place-report-details/market-place-report-details.component";
import { ServiceRecordsListComponent } from "src/app/components/common/service-records-list/service-records-list.component";
import { EstimateViewComponent } from 'src/app//components/common/estimate-view/estimate-view.component';
import { UnsubscribeComponent } from 'src/app/components//unsubscribe/unsubscribe.component';
import { TechsupportListSolrComponent } from 'src/app/components/common/techsupport-list-solr/techsupport-list-solr.component';
import { SelectSearchVehicleComponent,HighlightPipe } from 'src/app/components/common/select-search-vehicle/select-search-vehicle.component';
import { FixesSearchHistoryComponent } from 'src/app/components/common/fixes-search-history/fixes-search-history.component';
import { FixesClusteringListComponent } from 'src/app/components/common/fixes-clustering-list/fixes-clustering-list.component';
import { FixesClusteringInnerlistComponent,HighlightSearchinner } from 'src/app/components/common/fixes-clustering-innerlist/fixes-clustering-innerlist.component';
import { MoneyTransferLogComponent } from 'src/app/components/common/money-transfer-log/money-transfer-log.component';
import { AchPaymentInfoComponent } from 'src/app/components/common/ach-payment-info/ach-payment-info.component';
import { ViewThreadFixesDetailComponent } from 'src/app/components/common/view-thread-fixes-detail/view-thread-fixes-detail.component';
import { BannerAnnouncementWidgetComponent } from 'src/app/components/common/banner-announcement-widget/banner-announcement-widget.component';
import { YourThreadsWidgetV2Component } from 'src/app/components/common/your-threads-widget-v2/your-threads-widget-v2.component';
import { RecentServiceRecordsWidgetComponent } from 'src/app/components/common/recent-service-records-widget/recent-service-records-widget.component';
import { EquipmentWidgetComponent } from 'src/app/components/common/equipment-widget/equipment-widget.component';
import { RecentTechinfoWidgetV2Component } from 'src/app/components/common/recent-techinfo-widget-v2/recent-techinfo-widget-v2.component';
import { FieldSupportStaffWidgetComponent } from 'src/app/components/common/field-support-staff-widget/field-support-staff-widget.component';
import { ShopThreadsWidgetComponent } from 'src/app/components/common/shop-threads-widget/shop-threads-widget.component';
import { SummaryChartComponent } from 'src/app/components/common/summary-chart/summary-chart.component';
import { DashboardFilterV2Component } from 'src/app/components/common/dashboard-filter-v2/dashboard-filter-v2.component';
import { ByTechSupportChartComponent } from 'src/app/components/common/by-tech-support-chart/by-tech-support-chart.component';
import { FixesDashboardChartComponent } from 'src/app/components/common/fixes-dashboard-chart/fixes-dashboard-chart.component';
import { FilterV2Component } from 'src/app/components/common/filter-v2/filter-v2.component';
import { FixesSubscriptionExpiredComponent } from 'src/app/components/common/fixes-subscription-expired/fixes-subscription-expired.component';
import { UsageChartComponent } from 'src/app/components/common/usage-chart/usage-chart.component';
import { DashboardThreadsChartComponent } from 'src/app/components/common/dashboard-threads-chart/dashboard-threads-chart.component';
import { DashboardThreadsOpenChartComponent } from 'src/app/components/common/dashboard-threads-open-chart/dashboard-threads-open-chart.component';
import { DashboardThreadsCloseChartComponent } from 'src/app/components/common/dashboard-threads-close-chart/dashboard-threads-close-chart.component';
import { DashboardGtsChartComponent } from 'src/app/components/common/dashboard-gts-chart/dashboard-gts-chart.component';
import { ZoneWidgetsComponent } from 'src/app/components/common/zone-widgets/zone-widgets.component';
import { CalproAdasReportComponent } from 'src/app/components/common/calpro-adas-report/calpro-adas-report.component';
import { AutelRoFormComponent } from 'src/app/components/common/autel-ro-form/autel-ro-form.component';
import { GenericRoFormComponent } from 'src/app/components/common/generic-ro-form/generic-ro-form.component';
import { StripeCardsComponent } from 'src/app/components/common/stripe-cards/stripe-cards.component';
import { IscanRoFormComponent } from 'src/app/components/common/iscan-ro-form/iscan-ro-form.component';
import { ChangePwdTempComponent } from 'src/app/components/common/change-pwd-temp/change-pwd-temp.component';
import { SubscribersListComponent } from 'src/app/components/common/subscribers-list/subscribers-list.component';

import { DecimalPlacePipe } from './pipes/decimal-place.pipe';

import { PdfSearchComponent } from './components/common/pdf-search/pdf-search.component';
import { ViewPdfSearchComponent } from './components/common/view-pdf-search/view-pdf-search.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { HighlightTextPipe } from './pipes/highlight-text.pipe';
import { UserAddComponent } from "../headquarters/user-add/user-add.component";
import { UserGridInfoComponent } from "../headquarters/user-grid-info/user-grid-info.component";
import { UserListComponent } from '../headquarters/user-list/user-list.component';
import { UserDashboardComponent } from '../headquarters/user-dashboard/user-dashboard.component';
import { ShopRenamePopupComponent } from "./shoprename-popup/shoprename-popup.component";
import { UserProfileSectionComponent } from 'src/app/components/common/user-profile-section/user-profile-section.component';
import { UserProfileSectionManageComponent } from 'src/app/components/common/user-profile-section-manage/user-profile-section-manage.component';
import { ToolsListComponent } from '../headquarters/tools-list/tools-list.component';
import { AddToolsComponent } from "../headquarters/add-tools/add-tools.component";
import { AddProductComponent } from "../headquarters/add-product/add-product.component";
import { ToolsListLocationsComponent } from "../headquarters/tools-list-locations/tools-list-locations.component";
import { ProductHistoryComponent } from '../headquarters/product-history/product-history.component';
import { UpdatenamePopupComponent } from './updatename-popup/updatename-popup.component';
import { localDatePipe } from "../headquarters/headquarters/locaDatePipe";
import { AddProductStepOneComponent } from "../headquarters/add-product-step-one/add-product-step-one.component";
import { ProductDetailsComponent } from "../headquarters/product-details/product-details.component";
import { ProductDetailViewPopupComponent } from './product-detail-view-popup/product-detail-view-popup.component';
import { ImagePreviewViewComponent } from "src/app/components/common/image-preview-view/image-preview-view.component";
import { ServiceAreaCoveredComponent } from 'src/app/components/common/service-area-covered/service-area-covered.component';
import { UploaddocEditorComponent } from './uploaddoc-editor/uploaddoc-editor.component';
import { ServiceAreaStatesComponent } from 'src/app/components/common/service-area-states/service-area-states.component';
import { XcelMetricsComponent } from "src/app/components/common/xcel-metrics/xcel-metrics.component";
import { RenamePopupComponent } from './rename-popup/rename-popup.component';
import { DocViewComponent } from 'src/app//components/common/doc-view/doc-view.component';
import { NewThreadBeforeComponent } from '../../components/common/new-thread-before/new-thread-before.component';
import { SummaryChartAcxComponent } from '../../components/common/summary-chart-acx/summary-chart-acx.component';
import { DispatchMapComponent } from '../../components/common/dispatch-map/dispatch-map.component';
import { ShopLocationsComponent } from './components/common/shop-locations/shop-locations.component';
import { LocationSearchHeaderComponent } from 'src/app/layouts/location-search-header/location-search-header.component';
import { SalesDashboardComponent } from '../../components/common/sales-dashboard/sales-dashboard.component';
import { SubscriptionDashboardComponent } from '../../components/common/subscription-dashboard/subscription-dashboard.component';
import { SalesType1DashboardComponent } from '../../components/common/sales-type1-dashboard/sales-type1-dashboard.component';
import { SalesType2DashboardComponent } from '../../components/common/sales-type2-dashboard/sales-type2-dashboard.component';
import { ProfitMarginDefaultComponent } from '../../components/common/profit-margin-default/profit-margin-default.component';
import { ProfitMarginHomeComponent } from '../../components/common/profit-margin-home/profit-margin-home.component';
import { ProfitMarginSalesComponent } from '../../components/common/profit-margin-sales/profit-margin-sales.component';
import { ProfitMarginProfitComponent } from '../../components/common/profit-margin-profit/profit-margin-profit.component';
import { ProfitMarginVacationComponent } from '../../components/common/profit-margin-vacation/profit-margin-vacation.component';
import { ProfitMarginTechComponent } from '../../components/common/profit-margin-tech/profit-margin-tech.component';
import { ProfitMarginTimecardComponent } from '../../components/common/profit-margin-timecard/profit-margin-timecard.component';
import { SwithToMultipleAccountComponent } from '../../components/common/swith-to-multiple-account/swith-to-multiple-account.component';
import { TechJobsComponent } from '../../components/common/tech-jobs/tech-jobs.component';
import { RoInvoiceComponent } from '../../components/common/ro-invoice/ro-invoice.component';
import { AddShopPopupComponent } from 'src/app/modules/shop/shop/add-shop/add-shop.component';
import { ManageDekraListComponent } from '../../components/common/manage-dekra-list/manage-dekra-list.component';
import { NgxQRCodeModule } from "@techiediaries/ngx-qrcode";
import { ChromeDataComponent } from "../scannedvins/seannedvins/chrome-data/chrome-data.component";
import { OrderDetailPopupComponent } from './order-detail-popup/order-detail-popup.component';
import { ImageInfoPopupComponent } from './image-info-popup/image-info-popup.component';
import { InspectionEventManageComponent } from '../../components/common/inspection-event-manage/inspection-event-manage.component';
import { InspectionExecutionDetailsManageComponent } from '../../components/common/inspection-execution-details-manage/inspection-execution-details-manage.component';
import { InspectionEventManageDropdownComponent } from '../../components/common/inspection-event-manage-dropdown/inspection-event-manage-dropdown.component';
import { MagnifierComponent } from "src/app/components/magnifier/magnifier.component";
import { EquipmentListComponent } from '../headquarters/equipment-list/equipment-list.component';
import { EditToolsDetailInputComponent } from '../headquarters//edit-tool-detail-input/edit-tool-detail-input.component';
import { UserStatusMetricsComponent } from "src/app/components/common/user-status-metrics-widgets/user-status-metrics-widgets.component";
import { SelectGroupListComponent } from "src/app/components/common/select-group-list/select-group-list.component";
import { SelectLocationListComponent } from "src/app/components/common/select-location-list/select-location-list.component";
import {CcsecureDataComponent} from "../scannedvins/seannedvins/ccsecure-data/ccsecure-data.component";
import { MessageService } from "primeng/api";
import { EditNetworkShopNamePopupComponent } from './edit-network-shop-name-popup/edit-network-shop-name-popup.component';
import { EditNetworkIdPopupComponent } from './edit-network-id-popup/edit-network-id-popup.component';
import { PartsInventorySerialManageComponent } from "src/app/components/common/parts-inventory-serial-manage/parts-inventory-serial-managel.component";
import { ByTechSupportByMonthChartComponent } from 'src/app/components/common/by-tech-support-by-month-chart/by-tech-support-by-month-chart.component';
import { DailyTicketCreatedComponent } from 'src/app/components/common/daily-ticket-created/daily-ticket-created.component';
import { DispatchActionTemplateComponent } from "src/app/components/common/dispatch-action-template/dispatch-action-template.component";
import { DetailPopupComponent } from './detail-popup/detail-popup.component';
import { ManageJobsComponent } from 'src/app/components/common/manage-jobs/manage-jobs.component';
import { AutelScanToolRegComponent } from "src/app/components/common/autel-scan-tool-reg-widget/autel-scan-tool-reg-widget.component";
import { MyShortcutsWidgetsComponent } from "src/app/components/common/my-shortcuts-widgets/my-shortcuts-widgets.component";
import { DragDropDirective } from "src/app/common/directive/drag-drop.directive";
import { SelectJobsListComponent } from "src/app/components/common/select-jobs-list/select-jobs-list.component";
import { SkeletonModule } from 'primeng/skeleton';
import { JobsReportListComponent } from "src/app/components/common/jobs-report-list/jobs-report-list.component";
import { DispatchMapSolrComponent } from "src/app/components/common/dispatch-map-solr/dispatch-map-solr.component";
import { AddTaskPopupComponent } from "./add-task-popup/add-task-popup.component";
import { SalesListComponent } from 'src/app/components/common/sales-list/sales-list/sales-list.component';
import { AssignedTechComponent } from 'src/app/components/common/assigned-tech/assigned-tech/assigned-tech.component';
import { RepairOrderTimeMotionComponent } from 'src/app/components/common/repair-order-time-motion/repair-order-time-motion.component';
import { RepairOrderLogComponent } from 'src/app/components/common/repair-order-log/repair-order-log.component';

// FullCalendarModule.registerPlugins([
//   // register FullCalendar plugins
//   dayGridPlugin,
//   interactionPlugin,
//   timegridPlugin,
//   resourceTimeGridPlugin
// ]);

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true,
};

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  declarations: [
    PaymentControllerComponent,
    ManualsPaymentControllerComponent,
    HeaderComponent,
    ProbingHeaderComponent,
    ProductHeaderComponent,
    SidebarComponent,
    MarketplaceSidebarComponent,
    FilterComponent,
    FooterComponent,
    RemoveWhiteSpacePipe,
    ConfirmationComponent,
    SubmitLoaderComponent,
    SuccessComponent,
    SuccessModalComponent,
    WorkstreamListComponent,
    ProductMakeComponent,
    ApplicationComponent,
    VehicleModelsComponent,
    EmissionsComponent,
    TagViewComponent,
    ErrorCodeViewComponent,
    FileAttachmentComponent,
    FileAttachmentOldComponent,
    FileAttachmentS3Component,    
    AudioDescAttachmentComponent,
    AudioAttachmentViewComponent,
    DynamicAttachmentComponent,
    DynamicAttachmentOldComponent,
    DynamicAttachmentViewComponent,
    KaCategoryComponent,
    DocListComponent,
    ExportFileComponent,
    UploadAttachmentsComponent,
    UploadExistingComponent,
    AttachmentViewComponent,
    SystemInfoViewComponent,
    ModelsComponent,
    YearsComponent,
    SecWorkstreamsComponent,
    GtsListsComponent,
    GtsListsSolrComponent,
    TagsComponent,
    ActionFormComponent,
    ErrorCodeListsComponent,
    ManageListComponent,
    ManageListComponentGTS,
    ManageGeoListComponent,
    RelatedThreadListsComponent,
    MakeComponent,
    LandingpageHeaderComponent,
    LandingLeftSideMenuComponent,
    DomainMembersComponent,
    AnnouncementListComponent,
    AnnouncementListSolrComponent,
    AnnouncementUserViewComponent,
    AnnouncementUserViewSolrComponent,
    AnnouncementWidgetsComponent,
    UserStatusMetricsComponent,
    AutelScanToolRegComponent,
    SelectGroupListComponent,
    SelectLocationListComponent,
    SelectJobsListComponent,
    JobsReportListComponent,
    EscalationWidgetsComponent,
    RecentViewedWidgetsComponent,
    RecentSearchesWidgetsComponent,
    MyMetricsWidgetsComponent,
    LandingReportWidgtsComponent,
    AddLinkComponent,
    AppUserNotificationsComponent,
    MediaTypesComponent,
    TotaluserPopupComponent,
    ManageUserComponent,
    ThreadsPageComponent,
    OpportunityListsComponent,
    KnowledgeArticlesComponent,
    KnowledgeBaseListComponent,
    KnowledgeArticlesSolrComponent,
    KaCategorySolrComponent,
    StatusComponent,
    MediaInfoComponent,
    PartsListComponent,
    PartCatgComponent,
    EmptyContainerComponent,
    AuthFooterComponent,
    AuthRightPanelComponent,
    AuthSuccessComponent,
    DomainUrlComponent,
    ForgotpasswordComponent,
    NonUserComponent,
    ContentPopupComponent,
    VerifyEmailComponent,
    OtpComponent,
    OtpModalPopupComponent,
    ProfileBusinessComponent,
    ProfilePersonalComponent,
    ProfileMetricsComponent,
    ProfileCertificateComponent,
    ChangePasswordComponent,
    CreateFolderComponent,
    CreateCategoryComponent,
    PhoneMaskDirective,
    ViewPolicyComponent,
    MultiSelectComponent,
    DynamicFieldsComponent,
    DynamicValuesComponent,
    DynamicPageViewComponent,
    DynamicDetailHeaderComponent,
    ImageCropperComponent,
    CertificationComponent,
    FollowersFollowingComponent,
    CommonNotificationsComponent,
    FilesComponent,
    FoldersComponent,
    NewEditHeaderComponent,
    ThreadDetailHeaderComponent,
    ThreadDetailViewComponent,
    DetailViewComponent,
    DocumentsComponent,
    DocumentsNewComponent,
    DocumentsOldComponent,
    DocumentApprovalComponent,
    ListComponent,
    KaizenApprovalComponent,
    KzListComponent,
    ApprovedKzListComponent,
    DocInfoComponent,
    DirectoryInfoComponent,
    CountryPhonenumberComponent,
    ExportPopupComponent,
    WelcomeHomeComponent,
    DaysLoginPOPUPComponent,
    SelectCountryComponent,
    StartGtsComponent,
    ManageProductCodesComponent,
    SibListComponent,
    SibApplicationComponent,
    DirectoryListComponent,
    CustomAccordionTabComponent,
    SupportRequestWidgetComponent,
    RecentTechInfoWidgetsComponent,
    MySupportRequestWidgetsComponent,
    MyRoWidgetsComponent,
    MyTicketsWidgetsComponent,
    MyShortcutsWidgetsComponent,
    TeamSupportRequestWidgetsComponent,
    RegisteredTrainingsWidgetsComponent,
    TeamMembersStatusWidgetsComponent,
    YourPerformanceStatsWidgetsComponent,
    RecentMacrosWidgetsComponent,
    MyPinnedContentComponent,
    DialogPopupComponent,
    NoPermissionPopupComponent,
    MediaUploadComponent,
    MediaAttachmentComponent,
    SafePipePipe,
    SafeHtmlPipe,
    RemoveMediaComponent,
    DragDropDirective,
    DispatchPageComponent,
    DispatchPageSolrComponent,
    DispatchMapComponent,
    StandardReportListComponent,
    TechsupportListComponent,
    TechStatusListComponent,
    TechsupportTeamListComponent,
    RequiredFieldsComponent,
    ThreadViewRecentComponent,
    ThreadViewReplyComponent,
    ThreadViewReplyPublicComponent,
    ThreadApprovalComponent,
    PopupComponent,
    ChatReplyMessagePopupComponent,
    PresetsManageComponent,
    PresetsListComponent,
    ViewDocumentDetailComponent,
    BugAndFeatureComponent,
    BugFeaDetailsComponent,
    ViewTraningDetailComponent,
    MarketplaceHeaderComponent,
    MarketplaceFooterComponent,
    MarketplaceSystemactivityComponent,
    ShopListComponent,
    ShopListMapComponent,
    ViewAnnouncementDetailComponent,
    AuditListComponent,
    InspectionListComponent,
    ViewKaDetailComponent,
    RepairOrderListComponent,
    ViewRoDetailComponent,
    RepairOrderDetailViewComponent,
    RepairOrderManageComponent,
    FaqListComponent,
    RoEstimationComponent,
    CalproAdasReportComponent,
    CustomerListComponent,
    CustomerListSolrComponent,
    XcelMetricsComponent,
    SearchFilterComponent,
    FixThreadsComponent,
    DashSummaryTopComponent,
    DashSummaryCenterComponent,
    AdasListComponent,
    AdasFilesComponent,
    AdasViewComponent,
    GtsSessionsListComponent,
    HeadquartersListComponent,
    HeadquartersHomeComponent,
    PaymentPopupComponent,
    RoEstimateListComponent,
    RoEstimateTopTemplateComponent,
    PaymentPopupComponent,
    SearchHistoryListComponent,
    ScannedvinsListComponent,
    ScannedvinsListNewComponent,
    DiagnosticProgrammingListComponent,
    UnProcessedListComponent,
    LogslistComponent,
    NpsVpsScoreListComponent,
    ManageContentModelFilesComponent,    
    ManageContentModelImagesComponent,
    ManageContentSplashImageComponent,
    ManageContentDirectoryListComponent,
    MarketPlaceReportDetailsComponent,
    ServiceRecordsListComponent,
    EstimateViewComponent,
    GenericRoFormComponent,
    AutelRoFormComponent,
    UnsubscribeComponent,
    TechsupportListSolrComponent,
    SelectSearchVehicleComponent,
    HighlightPipe,
    HighlightSearchinner,
    HighlightSearchFilter,
    HighlightSearchThreaddetail,
    FixesSearchHistoryComponent,
    FixesClusteringListComponent,
    FixesClusteringInnerlistComponent,
    ViewThreadFixesDetailComponent,
    BannerAnnouncementWidgetComponent,
    YourThreadsWidgetV2Component,
    RecentServiceRecordsWidgetComponent,
    EquipmentWidgetComponent,
    RecentTechinfoWidgetV2Component,
    FieldSupportStaffWidgetComponent,
    ShopThreadsWidgetComponent,
    SummaryChartComponent,
    DashboardFilterV2Component,
    MoneyTransferLogComponent,
    AchPaymentInfoComponent,
    ByTechSupportChartComponent,
    FixesDashboardChartComponent,
    FilterV2Component,
    FixesSubscriptionExpiredComponent,
    UsageChartComponent,
    DashboardThreadsChartComponent,
    DashboardThreadsOpenChartComponent,
    DashboardThreadsCloseChartComponent,
    DashboardGtsChartComponent,
    ZoneWidgetsComponent,
    StripeCardsComponent,
    IscanRoFormComponent,
    ChangePwdTempComponent,
    SubscribersListComponent,
    DecimalPlacePipe,
    PdfSearchComponent,
    ViewPdfSearchComponent,
    HighlightTextPipe,
    UserAddComponent,
    UserGridInfoComponent,
    UserListComponent,
    TaskListComponent,
    UserQlySectionManagePopupComponent,
    KpiPopupComponent,
    TaskListNestedCommentComponent,
    TasksViewReplyComponent,
    TaskListCommentComponent,
    TaskDetailsOverviewComponent,
    UserDashboardComponent,
    ShopRenamePopupComponent,
    UserProfileSectionComponent,
    UserProfileSectionManageComponent,
    ToolsListComponent,
    AddToolsComponent,
    AddProductComponent,
    ToolsListLocationsComponent,
    ProductHistoryComponent,
    UpdatenamePopupComponent,
    localDatePipe,
    AddProductStepOneComponent,
    ProductDetailsComponent,
    ProductDetailViewPopupComponent,
    ImagePreviewViewComponent,
    ServiceAreaCoveredComponent,
    UploaddocEditorComponent,
    ServiceAreaStatesComponent,
    RenamePopupComponent,
    DocViewComponent,
    NewThreadBeforeComponent,
    SummaryChartAcxComponent,
    ShopLocationsComponent,
    LocationSearchHeaderComponent,
    SalesDashboardComponent,
    SubscriptionDashboardComponent,
    SalesType1DashboardComponent,
    SalesType2DashboardComponent,
    ProfitMarginDefaultComponent,
    ProfitMarginHomeComponent,
    ProfitMarginSalesComponent,
    ProfitMarginProfitComponent,
    ProfitMarginVacationComponent,
    ProfitMarginTechComponent,
    ProfitMarginTimecardComponent,
    SwithToMultipleAccountComponent,
    TechJobsComponent,
    RoInvoiceComponent,
    AddShopPopupComponent,
    ManageDekraListComponent,
    ChromeDataComponent,
    OrderDetailPopupComponent,
    ImageInfoPopupComponent,
    InspectionEventManageComponent,
    InspectionExecutionDetailsManageComponent,
    InspectionEventManageDropdownComponent,
    EquipmentListComponent,
    EditToolsDetailInputComponent,
    MagnifierComponent,
    CcsecureDataComponent,
    EditNetworkShopNamePopupComponent,
    EditNetworkIdPopupComponent,
    PartsInventorySerialManageComponent,
    ByTechSupportByMonthChartComponent,
    DailyTicketCreatedComponent,
    CcsecureDataComponent,
    DispatchActionTemplateComponent,
    DetailPopupComponent,
    ManageJobsComponent,
    DispatchMapSolrComponent,
    AddTaskPopupComponent,
    SalesListComponent,
    AssignedTechComponent,
    RepairOrderTimeMotionComponent,
    RepairOrderLogComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        // GoogleChartsModule,
        ScrollingModule,
        ToastModule,
        DragDropModule,
        MatInputModule,
        CKEditorModule,
        MatButtonModule,
        MatSelectModule,
        MatFormFieldModule,
        MatExpansionModule,
        NgxMatSelectSearchModule,
        MatIconModule,
        MatChipsModule,
        MatTooltipModule,
        MatSliderModule,
        MatMomentDateModule,
        MatDatepickerModule,
        DpDatePickerModule,
        MatNativeDateModule,
        MatMenuModule,
        MatToolbarModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        ClickOutsideModule,
        FileUploadModule,
        NgbModule,
        NgbPopoverModule,
        DialogModule,
        DropdownModule,
        VirtualScrollerModule,
        PaginatorModule,
        MultiSelectModule,
        InputSwitchModule,
        InputNumberModule,
        MenubarModule,
        SliderModule,
        SidebarModule,
        TabViewModule,
        AccordionModule,
        InputTextModule,
        MatBadgeModule,
        EditorModule,
        InputTextModule,
        CalendarModule,
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        AngularFireMessagingModule,
        AngularFireModule.initializeApp(environment.firebase),
        HttpClientModule,
        GridsterModule,
        NgxMasonryModule,
        NgxYoutubePlayerModule,
        PerfectScrollbarModule,
        ImageCropperModule,
        TableModule,
        NgxIntlTelInputModule,
        NgxMaskModule.forRoot(),
        NgxDaterangepickerMd.forRoot(),
        BsDropdownModule,
        CardModule,
        PanelModule,
        ChipModule,
        ProgressBarModule,
        MenuModule,
        AutoCompleteModule,
        InputTextareaModule,
        ListboxModule,
        ChipsModule,
        // GMapModule,
        CheckboxModule,
        TagModule,
        TimelineModule,
        RadioButtonModule,
        CarouselModule,
        GalleriaModule,
        StripeModule.forRoot(''),
        InfiniteScrollModule,
        MatRadioModule,
        FullCalendarModule,
        NgxQRCodeModule,        
        SkeletonModule,
    ],

    exports: [
    AccordionModule,
    CommonModule,
    DragDropModule,
    FormsModule,
    CardModule,
    PanelModule,
    ReactiveFormsModule,
    DropdownModule,
    // GoogleChartsModule,
    ScrollingModule,
    MatInputModule,
    CKEditorModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatExpansionModule,
    NgxMatSelectSearchModule,
    MatIconModule,
    MatChipsModule,
    MatTooltipModule,
    MatSliderModule,
    MatMomentDateModule,
    MatDatepickerModule,
    DpDatePickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatToolbarModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    ClickOutsideModule,
    NgbModule,
    NgbPopoverModule,
    DialogModule,
    HeaderComponent,
    ProbingHeaderComponent,
    ProductHeaderComponent,
    SidebarComponent,
    MarketplaceSidebarComponent,
    FilterComponent,
    VehicleModelsComponent,
    EmissionsComponent,
    FooterComponent,
    RemoveWhiteSpacePipe,
    WorkstreamListComponent,
    ApplicationComponent,
    TagViewComponent,
    ErrorCodeViewComponent,
    AttachmentViewComponent,
    KnowledgeArticlesComponent,
    KnowledgeArticlesSolrComponent,
    KaCategorySolrComponent,
    KnowledgeBaseListComponent,
    FileAttachmentComponent,
    FileAttachmentOldComponent,
    FileAttachmentS3Component,
    AudioDescAttachmentComponent,
    AudioAttachmentViewComponent,
    DynamicAttachmentComponent,
    DynamicAttachmentOldComponent,
    DynamicAttachmentViewComponent,
    KaCategoryComponent,
    DocListComponent,
    ExportFileComponent,
    SystemInfoViewComponent,
    ModelsComponent,
    YearsComponent,
    SecWorkstreamsComponent,
    TagsComponent,
    GtsListsComponent,
    GtsListsSolrComponent,
    ActionFormComponent,
    ErrorCodeListsComponent,
    MakeComponent,
    FileUploadModule,
    SuccessModalComponent,
    InputTextModule,
    LandingpageHeaderComponent,
    LandingLeftSideMenuComponent,
    DomainMembersComponent,
    AnnouncementListComponent,
    AnnouncementListSolrComponent,
    AnnouncementUserViewComponent,
    AnnouncementUserViewSolrComponent,
    AnnouncementWidgetsComponent,
    UserStatusMetricsComponent,
    AutelScanToolRegComponent,
    SelectGroupListComponent,
    SelectLocationListComponent,
    SelectJobsListComponent,
    JobsReportListComponent,
    EscalationWidgetsComponent,
    RecentViewedWidgetsComponent,
    RecentSearchesWidgetsComponent,
    MyMetricsWidgetsComponent,
    LandingReportWidgtsComponent,
    MediaTypesComponent,
    MatBadgeModule,
    EditorModule,
    CalendarModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    HttpClientModule,
    FullCalendarModule,
    TotaluserPopupComponent,
    ThreadsPageComponent,
    OpportunityListsComponent,
    StatusComponent,
    MediaInfoComponent,
    PartsListComponent,
    PartCatgComponent,
    GridsterModule,
    NgxMasonryModule,
    NgxYoutubePlayerModule,
    PerfectScrollbarModule,
    EmptyContainerComponent,
    PaymentControllerComponent,
    ManualsPaymentControllerComponent,
    AuthFooterComponent,
    AuthRightPanelComponent,
    OtpComponent,
    ProfileBusinessComponent,
    ProfilePersonalComponent,
    ProfileMetricsComponent,
    ProfileCertificateComponent,
    PhoneMaskDirective,
    ViewPolicyComponent,
    MultiSelectComponent,
    DynamicFieldsComponent,
    DynamicPageViewComponent,
    PopupComponent,
    ChatReplyMessagePopupComponent,
    DynamicDetailHeaderComponent,
    CommonNotificationsComponent,
    DocumentsComponent,
    DocumentsNewComponent,
    DocumentsOldComponent,
    DocumentApprovalComponent,
    ListComponent,
    KaizenApprovalComponent,
    KzListComponent,
    ApprovedKzListComponent,
    DynamicValuesComponent,
    FilesComponent,
    FoldersComponent,
    NewEditHeaderComponent,
    ThreadDetailHeaderComponent,
    ThreadDetailViewComponent,
    DetailViewComponent,
    DocInfoComponent,
    DirectoryInfoComponent,
    CountryPhonenumberComponent,
    NgxIntlTelInputModule,
    ExportPopupComponent,
    SibListComponent,
    SibApplicationComponent,
    DirectoryListComponent,
    CustomAccordionTabComponent,
    SupportRequestWidgetComponent,
    RecentTechInfoWidgetsComponent,
    MySupportRequestWidgetsComponent,
    MyRoWidgetsComponent,
    MyTicketsWidgetsComponent,
    TeamSupportRequestWidgetsComponent,
    RegisteredTrainingsWidgetsComponent,
    TeamMembersStatusWidgetsComponent,
    YourPerformanceStatsWidgetsComponent,
    RecentMacrosWidgetsComponent,
    MyPinnedContentComponent,
    ChipModule,
    ProgressBarModule,
    MenuModule,
    MediaAttachmentComponent,
    AutoCompleteModule,
    InputTextareaModule,
    ListboxModule,
    InputNumberModule,
    MenubarModule,
    InputSwitchModule,
    SafePipePipe,
    SafeHtmlPipe,
    //AngularFireModule.initializeApp(environment.firebase),
    DispatchPageComponent,
    DispatchPageSolrComponent,
    DispatchMapComponent,
    StandardReportListComponent,
    // GMapModule,
    CheckboxModule,
    TechsupportListComponent,
    TechStatusListComponent,
    TechsupportTeamListComponent,
    RequiredFieldsComponent,
    ThreadViewRecentComponent,
    ThreadViewReplyComponent,
    ThreadViewReplyPublicComponent,
    ThreadApprovalComponent,
    PresetsListComponent,
    BugAndFeatureComponent,
    BugFeaDetailsComponent,
    MarketplaceHeaderComponent,
    MarketplaceFooterComponent,
    MarketplaceSystemactivityComponent,
    ShopListComponent,
    ShopListMapComponent,
    AuditListComponent,
    InspectionListComponent,
    RepairOrderListComponent,
    RepairOrderManageComponent,
    RepairOrderDetailViewComponent,
    FaqListComponent,
    RoEstimationComponent,
    CalproAdasReportComponent,
    CustomerListComponent,
    CustomerListSolrComponent,
    XcelMetricsComponent,
    SearchFilterComponent,
    FixThreadsComponent,
    DashSummaryTopComponent,
    DashSummaryCenterComponent,
    AdasListComponent,
    AdasFilesComponent,
    AdasViewComponent,
    GtsSessionsListComponent,
    HeadquartersListComponent,
    HeadquartersHomeComponent,
    PaymentPopupComponent,
    RoEstimateListComponent,
    RoEstimateTopTemplateComponent,
    SearchHistoryListComponent,
    ScannedvinsListComponent,
    ScannedvinsListNewComponent,
    DiagnosticProgrammingListComponent,
    UnProcessedListComponent,
    LogslistComponent,
    NpsVpsScoreListComponent,
    ManageContentModelFilesComponent,    
    ManageContentModelImagesComponent,
    ManageContentSplashImageComponent,
    ManageContentDirectoryListComponent,
    MarketPlaceReportDetailsComponent,
    ServiceRecordsListComponent,
    EstimateViewComponent,
    GenericRoFormComponent,
    AutelRoFormComponent,
    UnsubscribeComponent,
    TechsupportListSolrComponent,
    SelectSearchVehicleComponent,
    HighlightPipe,
    HighlightSearchinner,
    HighlightSearchFilter,
    HighlightSearchThreaddetail,
    FixesSearchHistoryComponent,
    FixesClusteringListComponent,
    FixesClusteringInnerlistComponent,
    BannerAnnouncementWidgetComponent,
    YourThreadsWidgetV2Component,
    RecentServiceRecordsWidgetComponent,
    EquipmentWidgetComponent,
    RecentTechinfoWidgetV2Component,
    FieldSupportStaffWidgetComponent,
    ShopThreadsWidgetComponent,
    SummaryChartComponent,
    DashboardFilterV2Component,
    MoneyTransferLogComponent,
    AchPaymentInfoComponent,
    ByTechSupportChartComponent,
    FixesDashboardChartComponent,
    FilterV2Component,
    UsageChartComponent,
    DashboardThreadsChartComponent,
    DashboardThreadsOpenChartComponent,
    DashboardThreadsCloseChartComponent,
    DashboardGtsChartComponent,
    ZoneWidgetsComponent,
    StripeCardsComponent,
    IscanRoFormComponent,
    SubscribersListComponent,
    DecimalPlacePipe,
    PdfSearchComponent,
    HighlightTextPipe,
    UserAddComponent,
    UserGridInfoComponent,
    UserListComponent,
    TaskListComponent,
    TaskListNestedCommentComponent,
    TasksViewReplyComponent,
    TaskListCommentComponent,
    TaskDetailsOverviewComponent,
    UserDashboardComponent,
    MatRadioModule,
    ShopRenamePopupComponent,
    UserProfileSectionComponent,
    UserProfileSectionManageComponent,
    ToolsListComponent,
    AddToolsComponent,
    AddProductComponent,
    ToolsListLocationsComponent,
    ProductHistoryComponent,
    localDatePipe,
    AddProductStepOneComponent,
    ProductDetailsComponent,
    ImagePreviewViewComponent,
    ServiceAreaCoveredComponent,
    UploaddocEditorComponent,
    ServiceAreaStatesComponent,
    DocViewComponent,
    SummaryChartAcxComponent,
    ShopLocationsComponent,
    LocationSearchHeaderComponent,
    SalesDashboardComponent,
    SubscriptionDashboardComponent,
    SalesType1DashboardComponent,
    SalesType2DashboardComponent,
    ProfitMarginDefaultComponent,
    ProfitMarginHomeComponent,
    ProfitMarginSalesComponent,
    ProfitMarginProfitComponent,
    ProfitMarginVacationComponent,
    ProfitMarginTechComponent,
    ProfitMarginTimecardComponent,
    SwithToMultipleAccountComponent,
    TechJobsComponent,
    AddShopPopupComponent,
    ManageDekraListComponent,
    InspectionEventManageComponent,
    InspectionExecutionDetailsManageComponent,
    InspectionEventManageDropdownComponent,
    EditToolsDetailInputComponent,
    PartsInventorySerialManageComponent,
    ByTechSupportByMonthChartComponent,
    DailyTicketCreatedComponent,
    EquipmentListComponent,
    ManageJobsComponent,
    SalesListComponent,
    AssignedTechComponent,
    RepairOrderTimeMotionComponent,
    RepairOrderLogComponent
],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    NgbActiveModal,
    MatMomentDateModule,
    MatDatepickerModule,
    DpDatePickerModule,
    ScrollTopService,
    NgxImageCompressService,
    FcmMessagingService,
    BsDropdownConfig,
    MessageService, 
  ],
  entryComponents: [
    ConfirmationComponent,
    SubmitLoaderComponent,
    SuccessComponent,
    ProductMakeComponent,
    ManageListComponent,
    ManageListComponentGTS,
    RelatedThreadListsComponent,
    UploadAttachmentsComponent,
    UploadExistingComponent,
    SuccessModalComponent,
    AddLinkComponent,
    AppUserNotificationsComponent,
    ManageGeoListComponent,
    ManageUserComponent,
    LandingLeftSideMenuComponent,
    AuthSuccessComponent,
    DomainUrlComponent,
    ForgotpasswordComponent,
    NonUserComponent,
    ContentPopupComponent,
    VerifyEmailComponent,
    OtpModalPopupComponent,
    ChangePasswordComponent,
    CreateFolderComponent,
    CreateCategoryComponent,
    CertificationComponent,
    ImageCropperComponent,
    FollowersFollowingComponent,
    ExportPopupComponent,
    WelcomeHomeComponent,
    DaysLoginPOPUPComponent,
    SelectCountryComponent,
    StartGtsComponent,
    ManageProductCodesComponent,
    DialogPopupComponent,
    NoPermissionPopupComponent,
    MediaUploadComponent,
    RemoveMediaComponent,
    PresetsManageComponent,
    PresetsListComponent,
    ViewTraningDetailComponent,
    ViewAnnouncementDetailComponent,
    ViewKaDetailComponent,
    ViewRoDetailComponent,
    RepairOrderManageComponent,
    ViewThreadFixesDetailComponent,
    FixesSubscriptionExpiredComponent,
    ChangePwdTempComponent,
    NewThreadBeforeComponent,
    InspectionEventManageComponent,
    InspectionExecutionDetailsManageComponent,
    InspectionEventManageDropdownComponent,
    DispatchActionTemplateComponent,
    ManageJobsComponent,
    AddTaskPopupComponent,
    KpiPopupComponent,
    UserQlySectionManagePopupComponent
  ],
  bootstrap: [ RepairOrderListComponent, RepairOrderManageComponent, SalesListComponent ],
  // entryComponents: [
  //   ConfirmationComponent,
  //   SubmitLoaderComponent,
  //   SuccessComponent,
  //   ProductMakeComponent,
  //   ManageListComponent,
  //   ManageListComponentGTS,
  //   RelatedThreadListsComponent,
  //   UploadAttachmentsComponent,
  //   UploadExistingComponent,
  //   SuccessModalComponent,
  //   AddLinkComponent,
  //   AppUserNotificationsComponent,
  //   ManageGeoListComponent,
  //   ManageUserComponent,
  //   LandingLeftSideMenuComponent,
  //   AuthSuccessComponent,
  //   DomainUrlComponent,
  //   ForgotpasswordComponent,
  //   NonUserComponent,
  //   ContentPopupComponent,
  //   VerifyEmailComponent,
  //   ChangePasswordComponent,
  //   CreateFolderComponent,
  //   CreateCategoryComponent,
  //   CertificationComponent,
  //   ImageCropperComponent,
  //   FollowersFollowingComponent,
  //   ExportPopupComponent,
  //   WelcomeHomeComponent,
  //   DaysLoginPOPUPComponent,
  //   SelectCountryComponent,
  //   StartGtsComponent,
  //   ManageProductCodesComponent,
  //   DialogPopupComponent,
  //   NoPermissionPopupComponent,
  //   MediaUploadComponent,
  //   RemoveMediaComponent,
  //   PresetsManageComponent,
  //   PresetsListComponent,
  //   ViewTraningDetailComponent,
  //   ViewAnnouncementDetailComponent,
  //   ViewKaDetailComponent,
  //   ViewRoDetailComponent,
  //   RepairOrderManageComponent,
  //   ViewThreadFixesDetailComponent,
  //   FixesSubscriptionExpiredComponent,
  //   ChangePwdTempComponent,
  //   NewThreadBeforeComponent,
  //   InspectionEventManageComponent,
  //   InspectionExecutionDetailsManageComponent,
  //   InspectionEventManageDropdownComponent,
  // ],
})
export class SharedModule {}
